module.exports = __webpack_public_path__ + "img/bg-1.04647152.png";